'use client';

import { createContext, useContext } from 'react';

interface AuthenticatedAPIsContextType {
  [key: string]: any;
}

const AuthenticatedAPIsContext = createContext<AuthenticatedAPIsContextType | undefined>(undefined);

export const AuthenticatedAPIsProvider = ({ children }) => {
  return (
    <AuthenticatedAPIsContext.Provider value={{}}>
      {children}
    </AuthenticatedAPIsContext.Provider>
  );
};

export const useAuthenticatedAPIs = () => useContext(AuthenticatedAPIsContext);
